
define('text!templates/parts/alert/alert-list.html',[],function () { return '<div class="alert-list"></div>\n';});

